export default "__VITE_ASSET__CeOKPxA___"